export enum ActiveEmployeeId {
    True = 1,
    False = 2
}
export class EmployeeProfileModel{
    employeeId: string = null!;
    companyId: number = 0;
    companyGuid: string = null!;
    firstName: string = ''!;
    middleName: string = null!;
    lastName: string = '';
    nickName: string = null!;
    birthday:  string = null!;
    workEmail: string | null = null!;
    workPhone: string = null!;
    workExtension: string = null!;
    homeEmail: string = null!;
    homePhone: string = null!;
    cellPhone: string = null!;
    addressId: number = null!;
    emergencyContactId: number = null!;
    isOwner: boolean = false;
    departmentId: number = null!;
    locationId: number = null!;
    jobId: number = null!;
    startDate: Date = null!;
    separationDate: string = null!;
    nextAnnualReviewDate: string = null!;
    payrollDetailId: number = null!;
    employeeW4detailId: number = null!;
    employeeHealthPlanCoverageId: number = null!;
    isActiveEmployeeId?: ActiveEmployeeId = ActiveEmployeeId.True;
    isActiveEmployee: boolean = true;
    activeFlag: boolean = true;
    externalEmployeeId: string = null!;
    externalEmployeeIdInUse: boolean = false;
    hasAvatarImage: boolean = false;
    avatarColor: string = null!;
    address: Address = new Address();
    department: Department = new Department();
    location: Location = new Location();
    job: Job = new Job();
    employeeW4Detail: EmployeeW4Detail = null!;
    employeeHealthPlanCoverage: EmployeeHealthPlanCoverage = null!;
    payrollDetail: PayrollDetail = null!;
    emergencyContact: EmergencyContact = null!;
    role: string = null!;
    isSubscribedToSmartTrackPlans: boolean = false;
}
export class Address{
    addressId: number = 0;
    street: string = null!;
    city: string = null!;
    stateId: number = null!;
    zipCode: string = null!;
    countryId: number = null!;
    provinceId: number = null!;
    otherProvince: string = null!;
}
export class Department{
    departmentId: number = 0;
    name: string = null!;
    companyId: number = null!;
}
export class Location{
    locationId: number = 0;
    name: string = null!;
    companyId: number = null!;
}
export class Job{
    jobId: number = 0;
    jobTitle: string = null!;
}
export class EmployeeW4Detail{
    employeeW4DetailId: number = 0;
    maritalStatusId: number = null!;
    meetsConditionForExemption: boolean = null!;
    numberOfAllowances: number = null!;
    additionalAmountWithheld: number = null!;
}
export class EmployeeHealthPlanCoverage{
    employeeHealthPlanCoverageId: number = 0;
    enrollmentDate: string = null!;
    numberOfDependents: number = null!;
    costPerMonth: number = null!;
}
export class PayrollDetail{
    payrollDetailId: number = 0;
    employeeClassificationTypeId: number = null!;
    payrollTypeId: number = null!;
    payRate: number = null!;
    maximumScheduledHours: number = null!;
    payrollPayTypeId:number = null!;
    overtimeClassificationId:number = null!;
    overtimeClassificationDate: string = null!;
}
export class EmergencyContact{
    emergencyContactId: number = 0;
    firstName: string = null!;
    lastName: string = null!;
    relationship: string = null!;
    emailAddress: string = null!;
    homePhone: string = null!;
    cellPhone: string = null!;
    addressId: number = null!;
    address: Address = new Address();
}
export class EmployeeStatus{
    status : string = null!;
    statusId : number = 0
}
export class EmployeesList {
avatarColor : string = null!;
employeeId: string = null!;
firstName: string = null!;
hasAvatarImage : boolean = null!;
isActiveEmployee : boolean = null!;
jobTitle : string = null!;
lastName : string = null!;
supervisor: string = null!;
}
